import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import {  CheckCircleFilled } from '@ant-design/icons';
import './index.scss';
import {  roundToWholeNumber, convertToHours } from '../../utils/utils';
import { formatWithCommas, formatNumber } from '../../utils/utils';


const SoaAtGlance = (props) => {
  const { trialId, scenarioId, saveCostChart,onSoALoadingChange, chartData, whetherSOA, soaOncologyFlag, soaGlanceData} = props;
 
  const [SOAByAtGlance, setSOAByAtGlance] = useState({
    pb_insights_data: {
      number_of_activities_soa: 0,
      number_of_activities_median: 0,
      number_of_visits_soa: 0,
      number_of_visits_median: 0,
      patient_burden_soa: 0,
      patient_burden_median: 0,
      cost_soa: 0,
      cost_median: 0,
    },
  });
  useEffect(() => {
    fetchChartData();
  }, [trialId, scenarioId, saveCostChart, soaGlanceData]);

  const fetchChartData = async () => {
    if (!scenarioId || scenarioId === '') {
      return;
    }
    if(soaGlanceData) {
     
      setSOAByAtGlance(soaGlanceData)
      onSoALoadingChange(false)
    } else {
      onSoALoadingChange(true)
      message.error('Failed to fetch SoA at a glance chart data');
    }
    
    };

    const whetherDisplay = (chartName, whetherSOA) => {
      const chart = chartData.find((chart: Chart) => chart.name === chartName);        
      if (chart) {
        return chart.selected && !whetherSOA
      }
    }

    const subHeaderText = () => {
      let periodType = props?.currentVisitTypes
      switch (periodType) {
        case 'Fixed Cycle':
          return ["Total","Per cycle","Per cycle","Per cycle","Per cycle"];
        case 'total_trial':
          return ["Simulated total trials","Simulated total trials","Simulated total trials","Simulated total trials","Simulated total trials"];
        case 'Repeating Cycle':
          return ["Total","Per cycle","Per cycle","Per cycle","Per cycle"];
        default:
          return [" "," "," "," "," "];
      }
    }
  
  // In case of digits going to 5 digits round off to thousand form
  const formatCost = (val) => {
    let cost = Math.round(val) 
    if (cost >= 1000000) {
      return `${(cost / 1000000).toFixed(0)}M`;
    } else if (cost >= 10000) {
      return `${(cost / 1000).toFixed(0)}K`;
    } else {
      return formatWithCommas(cost);
    }
  }
  const heightClass = soaOncologyFlag && props?.currentVisitTypes === 'total_trial' ? 'onc-total-trial-height' : '';
  const { pb_insights_data } = SOAByAtGlance ?? {};

  const displayTimeWithUnit = (time) => {
    if(time === null ){
      return '-';
    } 
    if(time > 60 ) {
      return ( <> {formatWithCommas(convertToHours(time?? '0'))} <span className='timeUnit'>h</span></> )
    } 
    return (<span className={`${formatNumber(time)?.length === 5 ?'large-number':''}`}>{formatNumber(time) ?? '0'}  <span className='timeUnit minTimeUnit'>mins</span></span>)
   
  }
  return (
    <div className=' soa-at-glance '>
      <div className='chart-header'>
        <div className='title'>
          SoA at a glance
          {/* <div className="icon-holder"><CheckCircleOutlined className="check-icon" style={{ background: '#97E095', color: 'white', borderRadius: '20px' }} /></div> */}
        </div>
        <CheckCircleFilled style={{color: '#97E095', display: `${whetherDisplay('SoA at a Glance',whetherSOA)?"block":"none"}`}}/>
      </div>
      <div className='chart-container  '>
        <div className="y-axis">
          <div className="vertical-text">  
            Your SoA
          </div>
          <div className="vertical-text">  
            Historic
          </div>
        </div>
        <div className='left-part left-part-first'>
          <div className={`left-part-top ${heightClass}`}>
            <div className='left-part-top-content'>
              <p className='item-wrapper-top-para'>Number of activities</p>
              <p className='item-wrapper-sub-header'>{soaOncologyFlag? subHeaderText()[0]: ""}</p>
            </div>
          </div>
          <div className='item-wrapper item-wrapper-top'>
            <div className='number'>
              {pb_insights_data?.number_of_activities_soa === null ? '-' : roundToWholeNumber(pb_insights_data?.number_of_activities_soa ?? '0')}
            </div>
          </div>
          <div className='item-wrapper item-wrapper-bottom'>
            <div className='number'>
              {pb_insights_data?.number_of_activities_median? roundToWholeNumber(pb_insights_data.number_of_activities_median?? '0'): '-'}
            </div>
          </div>
        </div>
        <div className='middle'> </div>
        <div className='left-part'>
          <div className={`left-part-top ${heightClass}`}>
            <div className='left-part-top-content'>
              <p className='item-wrapper-top-para'>Visits</p>
              <p className='item-wrapper-sub-header'>{soaOncologyFlag? subHeaderText()[1]: ""}</p>
            </div>
          </div>
          <div className='item-wrapper item-wrapper-top'>
            <div className='number'>
              {pb_insights_data?.number_of_visits_soa === null ? '-' : roundToWholeNumber(pb_insights_data.number_of_visits_soa?? '0')}
            </div>
          </div>
          <div className='item-wrapper item-wrapper-bottom'>
            <div className='number'>
              {pb_insights_data?.number_of_visits_median? roundToWholeNumber(pb_insights_data.number_of_visits_median?? '0'): '-'}
            </div>
          </div>
        </div>
        <div className='middle'> </div>
        <div className='left-part'>
          <div className={`left-part-top ${heightClass}`}>
            <div className='left-part-top-content'>
              <p className='item-wrapper-top-para'>Patient burden</p>
              <p className='item-wrapper-sub-header'>{soaOncologyFlag? subHeaderText()[2]: ""}</p>
            </div>
          </div>
          <div className='item-wrapper item-wrapper-top'>
            <div className='number'>
              {pb_insights_data?.patient_burden_soa === null ? '-' : formatWithCommas(Math.round(pb_insights_data.patient_burden_soa?? '0'))}
            </div>
          </div>
          <div className='item-wrapper item-wrapper-bottom'>
            <div className='number'>
              {pb_insights_data?.patient_burden_median? formatWithCommas(Math.round(pb_insights_data.patient_burden_median?? '0')): '-'}
            </div>
          </div>
        </div>
        <div className='middle'> </div>
        <div className='left-part'>
          <div className={`left-part-top ${heightClass}`}>
            <div className='left-part-top-content'>
              <p className='item-wrapper-top-para'>Site burden</p>
              <p className='item-wrapper-sub-header'>{soaOncologyFlag? subHeaderText()[4]: ""}</p>
            </div>
          </div>
          <div className='item-wrapper item-wrapper-top'>
            <div className='number'>
              {pb_insights_data?.site_burden_soa === null ? '-' : formatWithCommas(Math.round(pb_insights_data.site_burden_soa?? '0'))}
            </div>
          </div>
          <div className='item-wrapper item-wrapper-bottom'>
            <div className='number'>
              {pb_insights_data?.site_burden_median? formatWithCommas(Math.round(pb_insights_data.site_burden_median?? '0')): '-'}
            </div>
          </div>
        </div>
        <div className='middle'> </div>
        <div className='left-part'>
          <div className={`left-part-top ${heightClass}`}>
            <div className='left-part-top-content'>
              <p className='item-wrapper-top-para'>Patient time</p>
              <p className='item-wrapper-sub-header'>{soaOncologyFlag? subHeaderText()[4]: ""}</p>
            </div>
          </div>
          <div className='item-wrapper item-wrapper-top'>
            <div className='number'>
              {displayTimeWithUnit(pb_insights_data?.time_burden_soa )}
            </div>
          </div>
          <div className='item-wrapper item-wrapper-bottom'>
            <div className='number'>
              {displayTimeWithUnit(pb_insights_data?.time_burden_median )}
            </div>
          </div>
        </div>
        <div className='middle'> </div>
        <div className='left-part'>
          <div className={`left-part-top ${heightClass}`}>
            <div className='left-part-top-content'>
              <p className='item-wrapper-top-para'>Cost per patient</p>
              <p className='item-wrapper-sub-header'>{soaOncologyFlag? subHeaderText()[3]: ""}</p>
            </div>
          </div>
          <div className='item-wrapper item-wrapper-top'>
            <div className='number'>
              {pb_insights_data?.cost_soa === null ? '-' : `$${formatCost(pb_insights_data?.cost_soa ?? '0')}`}
            </div>
          </div>
          <div className='item-wrapper item-wrapper-bottom'>
            <div className='number'>
              {pb_insights_data?.cost_median? `$${formatCost(pb_insights_data.cost_median?? '0')}`: '-'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

  export default SoaAtGlance;